// extracted by mini-css-extract-plugin
export default {"container":"Ip-z","bubbleNav":"Jp-z","graphic":"Kp-z","contact":"Lp-z"};